import { axios } from '@/utils/request'

// 应用管理
export function getCallReportList (parameter = {}) {
  return axios({
    url: '/collectorCallCountReport/list',
    method: 'post',
    data: parameter
  })
}
